export default {
    isDemo: true,
    version: '2.19.0',
    //appCode: "fulrl",
    appCode: '2gjjy',
};
